import { render, staticRenderFns } from "./VerticalSpacer.vue?vue&type=template&id=c94ca032&"
var script = {}
import style0 from "./VerticalSpacer.vue?vue&type=style&index=0&id=c94ca032&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports